/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ok': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11z" _fill="#F00"/><path pid="1" d="M16.8 8.404l-6.131 6.133-2.916-2.916a.5.5 0 0 0-.707.707l3.27 3.27a.5.5 0 0 0 .708 0l6.485-6.486a.5.5 0 0 0-.708-.708z" _fill="#F00"/>'
  }
})
